module.exports = __webpack_public_path__ + "img/setType-m.872fb8b9.png";